export default __webpack_public_path__ + "static/media/dog_1.1b235bb7.png";